var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Show-Theater-Mask-Sad--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Show Theater Mask Sad Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.35 0.27A1.45 1.45 0 0 0 21 0.09c-3.95 1.47 -14 1.47 -18 0a1.45 1.45 0 0 0 -1.35 0.18A1.49 1.49 0 0 0 1 1.51V12c0 6.75 8.77 12 11 12s11 -5.25 11 -12V1.51a1.49 1.49 0 0 0 -0.65 -1.24ZM5.12 7.88a0.75 0.75 0 0 1 0.27 -1 0.77 0.77 0 0 1 1 0.27 1.29 1.29 0 0 0 2.16 0 0.76 0.76 0 0 1 1 -0.27 0.75 0.75 0 0 1 0.27 1 2.75 2.75 0 0 1 -4.76 0ZM16 18.25H8a0.76 0.76 0 0 1 -0.75 -0.75c0 -2.07 2.13 -3.75 4.75 -3.75s4.75 1.68 4.75 3.75a0.76 0.76 0 0 1 -0.75 0.75Zm2.88 -10.37a2.75 2.75 0 0 1 -4.76 0 0.75 0.75 0 0 1 0.27 -1 0.76 0.76 0 0 1 1 0.27 1.29 1.29 0 0 0 2.16 0 0.77 0.77 0 0 1 1 -0.27 0.75 0.75 0 0 1 0.33 1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrama);
export default ForwardRef;